/**
 * Created by Olga Eremina on 26.10.2026
 */

const BoardFullTutorial = function () {
    return new TutorialScenario(BoardFullTutorial.NAME, {
        manual: true,
        restore: false,
        keepControls: true,

        onStart: function () {
            cleverapps.focusManager.showControlsWhileFocused([Merge2.current.getUpContainerControls(), "unitInfoView", "backpackButton"], true);
            cleverapps.tutorial.on("onResize", () => {
                const hint = BoardFullHelper.currentHint;
                if (!hint || !hint.dialogue) {
                    if (cleverapps.forces.isRunningForce()) {
                        cleverapps.forces.closeRunningForce();
                    }
                    cleverapps.tutorial.stop("resize");
                    return;
                }

                hint.hintView.show(hint.move, true);
            }, cleverapps.tutorial);
        },

        listSteps: BoardFullTutorial.listSteps,

        onFinish: function () {
            const hint = BoardFullHelper.currentHint;
            if (hint) {
                hint.hide();
            }
        }
    });
};

BoardFullTutorial.NAME = "board_full_tutorial";

BoardFullTutorial.listSteps = function () {
    const hint = BoardFullHelper.currentHint;
    const dialogue = hint.dialogue;
    const isFirstTime = !BoardFullHelper.getData();
    const isFirstByType = !hint.lastTime;
    const steps = [];
    if (isFirstTime) {
        steps.push(BoardFullTutorial.createHelpStep(dialogue));
        steps.push(BoardFullTutorial.createGuideStep());
    }
    steps.push(BoardFullTutorial.createOkStep(dialogue, isFirstByType));
    steps.push(...BoardFullTutorial.createHintSteps(hint));
    return steps;
};

BoardFullTutorial.createIntroButtonStep = function (dialogue, data) {
    return new TutorialStep({
        onStart: function () {
            const showForce = () => {
                if (this.force && cleverapps.forces.getRunningForce() === this.force) {
                    cleverapps.forces.closeRunningForce();
                }

                if (cleverapps.focusManager.getFocus() === BoardFullHelper.GUIDE_FOCUS) {
                    return;
                }

                [dialogue.okButton, dialogue.cancelButton, dialogue.helpButton].filter(Boolean).forEach((intraButton) => {
                    intraButton.alwaysOn = false;
                });

                const target = dialogue[data.target];
                const actives = [target];
                if (data.allowCancel && dialogue.cancelButton) {
                    actives.push(dialogue.cancelButton);
                }
                if (data.allowHelp && dialogue.helpButton) {
                    actives.push(dialogue.helpButton);
                }

                this.force = Merge2TutorialHelper.createForce(target, {
                    shadow: data.shadow,
                    finger: data.finger
                }, {
                    actives,
                    highlights: [dialogue],
                    importantNodes: [dialogue]
                });
            };

            showForce();
            cleverapps.tutorial.on("onResize", showForce, this);
            cleverapps.tutorial.on("window_closed", (options) => {
                if (options.windowName === "BoardFullGuideWindow") {
                    showForce();
                }
            }, this);

            cleverapps.tutorial.on(data.finishEvent, (options) => {
                if (!data.finishFilter || data.finishFilter(options)) {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            if (this.force && cleverapps.forces.getRunningForce() === this.force) {
                cleverapps.forces.closeRunningForce();
            }
            Merge2.current.counter.trigger();
        }
    });
};

BoardFullTutorial.createHelpStep = function (dialogue) {
    return BoardFullTutorial.createIntroButtonStep(dialogue, {
        target: "helpButton",
        finishEvent: "window_shown",
        finishFilter: (options) => options.windowName === "BoardFullGuideWindow"
    });
};

BoardFullTutorial.createGuideStep = function () {
    return new TutorialStep({
        onStart: function () {
            cleverapps.tutorial.on("window_closed", (options) => {
                if (options.windowName === "BoardFullGuideWindow") {
                    this.finish();
                }
            }, this);
        },

        onFinish: function () {
            Merge2.current.counter.trigger();
        }
    });
};

BoardFullTutorial.createOkStep = function (dialogue, isFirstByType) {
    return BoardFullTutorial.createIntroButtonStep(dialogue, {
        target: "okButton",
        shadow: isFirstByType,
        finger: isFirstByType ? undefined : false,
        allowCancel: !isFirstByType,
        allowHelp: !isFirstByType,
        finishEvent: "BoardFullHelperAcceptHint"
    });
};

BoardFullTutorial.createHintSteps = function (hint) {
    const move = hint.move;
    if (move.type === CollectibleHintLogic.type || move.type === CollectibleLastStageHintLogic.type) {
        return [BoardFullTutorial.createCollectStep(move)];
    }
    if (move.type === BackpackHintLogic.type) {
        return [BoardFullTutorial.createBackpackStep(hint)];
    }
    return BoardFullTutorial.createRemoveSteps(move);
};

BoardFullTutorial.createHintForce = function (move, actives, highlights) {
    const force = cleverapps.forces.create(ForceView.NO_ELEMENT, {
        text: BoardFullHelper.HINTS[move.type].text,
        shadow: true,
        closeByTouchInShadow: false
    }, {
        actives,
        highlightActives: false,
        highlights,
        importantNodes: highlights
    });
    Merge2TutorialHelper.highlightSelection(force);
    return force;
};

BoardFullTutorial.createCollectStep = function (move) {
    const unit = move.target.unit;

    return new TutorialStep({
        onCheckConditions: function (options) {
            return Unit.Equals(options.unit, unit);
        },

        onStart: function () {
            const mapView = Merge2.current.field.getMapView();
            const unitView = unit.onGetView();
            const tile = mapView.getTileView(unit.x, unit.y);
            this.force = BoardFullTutorial.createHintForce(move, [unitView], [tile, unitView, cleverapps.Scenes.GetMovingNode()]);

            cleverapps.tutorial.on("collectibleArrived", this.finish.bind(this), this);
        },

        onFinish: function () {
            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    });
};

BoardFullTutorial.createBackpackStep = function (hint) {
    const move = hint.move;
    const unit = move.target.unit;

    return new TutorialStep({
        onCheckConditions: function (options) {
            if (options.backpack) {
                return true;
            }
            return Unit.Equals(options.unit, unit);
        },

        onStart: function () {
            const backpack = cleverapps.aims.getTarget("backpack");
            if (!backpack.isButtonInactive) {
                backpack.disable();
                addCleaner(this, backpack.enable.bind(backpack));
            }
            const mapView = Merge2.current.field.getMapView();
            const unitView = unit.onGetView();
            const tile = mapView.getTileView(unit.x, unit.y);
            this.force = BoardFullTutorial.createHintForce(move, [unitView, backpack, cleverapps.Scenes.GetMovingNode()], [tile, unitView, backpack]);

            const restartHint = () => {
                if (this.showTimeout) {
                    cleverapps.timeouts.clearTimeout(this.showTimeout);
                    this.showTimeout = undefined;
                }
                hint.hintView.hide(true);
                if (!Merge2.current.field.dragging) {
                    this.showTimeout = cleverapps.timeouts.setTimeout(() => {
                        hint.hintView.show(move, true);
                    }, 500);
                }
            };

            Merge2.current.field.on("changeDragging", restartHint, this);
            Merge2.current.field.on("unitSelectionChanged", (selectedUnit, isDragging) => {
                if (!isDragging && Unit.Equals(selectedUnit, unit)) {
                    restartHint();
                }
            }, this);

            Merge2.current.backpack.on("onInsertUnit", this.finish.bind(this), this);
        },

        onFinish: function () {
            if (this.showTimeout) {
                cleverapps.timeouts.clearTimeout(this.showTimeout);
                this.showTimeout = undefined;
            }

            this.force && this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    });
};

BoardFullTutorial.createRemoveSteps = function (move) {
    const unit = move.target.unit;

    return [
        Merge2TutorialHelper.createClickUnitStep({
            filter: (candidate) => Unit.Equals(candidate, unit),
            finishEvent: "unitSelectionChanged",
            text: "BoardFullHint.remove",
            highlightedCells: true
        }),
        Merge2UndoTutorial.createRemoveStep({ text: undefined, shadow: true }),
        Merge2UndoTutorial.createConfirmStep({ text: undefined, shadow: true })
    ];
};
